import { useState, useEffect } from 'react';

export default function RedditFeed() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSubreddit, setActiveSubreddit] = useState('racing');

  const subreddits = ['racing', 'simracing', 'Karting', 'formula1', 'cars', 'Trackdays'];

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    // Use CORS proxy to bypass Reddit's CORS restrictions
    const corsProxy = 'https://corsproxy.io/?';
    const redditUrl = `https://www.reddit.com/r/${activeSubreddit}/hot.json?limit=10`;
    
    fetch(corsProxy + encodeURIComponent(redditUrl))
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (data?.data?.children) {
          setPosts(data.data.children.map(child => child.data));
        } else {
          throw new Error('Invalid data format');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Reddit fetch error:', err);
        setError(err.message);
        setLoading(false);
      });
  }, [activeSubreddit]);

  if (loading) {
    return (
      <div style={{ padding: 20, color: '#888' }}>
        Loading r/{activeSubreddit}...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 20, color: '#ff4500' }}>
        <div style={{ marginBottom: 10 }}>⚠️ Reddit feed error: {error}</div>
        <button
          onClick={() => setActiveSubreddit(activeSubreddit)}
          style={{
            background: '#ff4500',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '8px 16px',
            cursor: 'pointer'
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div style={{
      background: '#1a1a1a',
      height: '100%',
      overflow: 'auto',
      padding: 15
    }}>
      <h3 style={{ 
        color: '#ff4500', 
        margin: '0 0 10px 0',
        fontSize: 18,
        borderBottom: '2px solid #ff4500',
        paddingBottom: 10
      }}>
        🏁 r/{activeSubreddit}
      </h3>

      {/* Subreddit switcher buttons */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        marginBottom: 15
      }}>
        {subreddits.map(sub => (
          <button
            key={sub}
            onClick={() => setActiveSubreddit(sub)}
            style={{
              background: activeSubreddit === sub ? '#ff4500' : '#333',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '6px 12px',
              fontSize: 11,
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontWeight: activeSubreddit === sub ? 'bold' : 'normal'
            }}
            onMouseEnter={(e) => {
              if (activeSubreddit !== sub) {
                e.currentTarget.style.background = '#444';
              }
            }}
            onMouseLeave={(e) => {
              if (activeSubreddit !== sub) {
                e.currentTarget.style.background = '#333';
              }
            }}
          >
            r/{sub}
          </button>
        ))}
      </div>

      {posts.map(post => (
        <div key={post.id} style={{
          background: '#0d1117',
          border: '1px solid #333',
          borderRadius: 8,
          padding: 12,
          marginBottom: 12,
          cursor: 'pointer',
          transition: 'border-color 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.borderColor = '#ff4500'}
        onMouseLeave={(e) => e.currentTarget.style.borderColor = '#333'}
        onClick={() => window.open(`https://reddit.com${post.permalink}`, '_blank')}
        >
          {/* Thumbnail */}
          {post.thumbnail && post.thumbnail !== 'self' && post.thumbnail !== 'default' && (
            <img 
              src={post.thumbnail} 
              alt=""
              style={{
                width: 70,
                height: 70,
                objectFit: 'cover',
                borderRadius: 4,
                float: 'left',
                marginRight: 12
              }}
            />
          )}

          {/* Title */}
          <div style={{
            color: '#fff',
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: 6,
            lineHeight: 1.3
          }}>
            {post.title}
          </div>

          {/* Meta */}
          <div style={{
            color: '#888',
            fontSize: 11,
            clear: 'both',
            paddingTop: 8
          }}>
            <span style={{ color: '#ff4500' }}>↑ {post.ups}</span>
            {' • '}
            <span>{post.num_comments} comments</span>
            {' • '}
            <span>u/{post.author}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
